import { FGTextAreaInput } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";
import * as Yup from "yup";

import { TitleTypeApi, TitleTypeDto, TitleTypeTranslationDto } from "../../../../api";
import { FGMultiTranslate, SmallFormGenerator } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { ERoutes } from "../../../../ERoutes";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";

export interface ITitleTypeDetailsProps {
  titleTypeId: number;
  editMode: boolean;
}

export const TitleTypeDetails: React.FunctionComponent<ITitleTypeDetailsProps> = ({ titleTypeId, editMode }) => {
  const { t } = useTl();
  const api = useApiService(TitleTypeApi);
  const history = useHistory();
  const { languages } = useGlobalData();
  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      translations: Yup.array().of(
        Yup.object().shape({
          text: Yup.string().nullable().required(t(ETLCodes.Required)),
        })
      ),
    });
  }, [t]);
  const { data, loading, deleteItem, deleting, saveItem, saving } = useCrudApi(
    {
      getApiFn: (id = titleTypeId) =>
        id > 0
          ? api.get(id)
          : new TitleTypeDto({
              translations: [
                ...languages.map(
                  (l) =>
                    new TitleTypeTranslationDto({
                      languageId: l.languageId,
                    })
                ),
              ],
            }).toJSON(),
      saveApiFn: (d: TitleTypeDto) => api.save(d),
      onSavedRoute: (d) => `${ERoutes.titleType}/${d.titleTypeId}/detail/edit`,
      deleteApiFn: (d) => api.delete(d.titleTypeId),
      onDeletedRoute: () => ERoutes.titleType,
    },
    [titleTypeId]
  );
  return (
    <SmallFormGenerator
      initialValues={data}
      onSubmit={saveItem}
      editMode={editMode}
      validationSchema={FormSchema}
      loading={loading}
      onCancel={() => history.push(ERoutes.titleType)}
      onDelete={deleteItem}
      showDeleteButton={titleTypeId > 0}
      saving={saving}
      deleting={deleting}
    >
      <FGMultiTranslate
        label={ETLCodes.Name}
        translationsArrayField="translations"
        translationField="text"
        translationDto={TitleTypeTranslationDto}
      />
      <FGTextAreaInput name="remark" label={t(ETLCodes.Remark)} />
    </SmallFormGenerator>
  );
};
